import { useTranslation } from 'react-i18next';

export default function IntroVietnam() {
  const { t } = useTranslation();
  return (
    <section className="w-full bg-background-200 pt-12 pb-8 md:pt-16 md:pb-12 lg:pt-20 lg:pb-12">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Video + description */}
        <div className="mx-auto flex w-full max-w-[1000px] flex-col gap-5">
          <div className="relative aspect-[16/9] w-full overflow-hidden rounded-xl bg-black">
            <iframe
              className="absolute inset-0 h-full w-full"
              src="https://www.youtube-nocookie.com/embed/go47OjFIzkg?rel=0&playsinline=1"
              title={t('intro.videoTitle')}
              referrerPolicy="strict-origin-when-cross-origin"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
              allowFullScreen
            />
          </div>
          <p className="text-[12px] leading-[1.6] text-secondary-500 md:text-sm">
            {t('intro.text')}
          </p>
        </div>
      </div>
    </section>
  );
}